import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { IObjectPropertiesDeviceModel, IObjectPropertiesTankModel, IObjectPropertiesTankBatteryModel, IObjectPropertiesWellModel, ITagProperties } from "../../services/properties-data-service/Models";
import PropertiesDataService from "../../services/properties-data-service/PropertiesDataService";

import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { MutationContextType } from "./Common";

import { keys } from "./Keys";
import {keys as drcxKeys} from "../drcx/Keys"


// use this as an alias for readability here
type PropertiesType = {

} & (IObjectPropertiesDeviceModel |
IObjectPropertiesTankModel |
IObjectPropertiesTankBatteryModel |
IObjectPropertiesWellModel | 
ITagProperties)

export type UseSaveObjectPropertiesQueryParams = {
    groupID: number, 
    eLynxObject: IeLynxObject,    
} & BaseUseQueryParameters<void>;

export function useSaveObjectProperties(params: UseSaveObjectPropertiesQueryParams) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, PropertiesType, MutationContextType>(
        (properties) => {
            return PropertiesDataService.saveProperties(params.groupID, params.eLynxObject, properties)
        },
        {
            onMutate: async (properties: PropertiesType) => {

                await queryClient.cancelQueries(keys.all);

                const previousProperties = queryClient.getQueryData<PropertiesType | undefined>(
                    keys.properties(params.groupID, params.eLynxObject)
                );

                queryClient.setQueryData<PropertiesType>(
                    keys.properties(params.groupID, params.eLynxObject),
                    (old?: PropertiesType) => {
                        return old ?? properties;
                    }
                );

                return {
                    previousProperties: previousProperties
                };
            },
            onError: params.onError,
            onSuccess: params.onSuccess,
            onSettled: (_data, error, _props, context) => {

                if (error && context?.previousProperties) {
                    queryClient.setQueryData<PropertiesType>(
                        keys.properties(params.groupID, params.eLynxObject),
                        context?.previousProperties
                    );
                }

                queryClient.invalidateQueries([keys.all, drcxKeys.availableDeviceTypes(params.groupID)]);
                
                queryClient.refetchQueries(drcxKeys.availableDeviceTypes(params.groupID));
               
            }
        }
    );
}
